import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { getConfig } from '../../configs/config'

const browserHistory = createBrowserHistory({ basename: '' })
const userInfoData = localStorage.getItem('userInfoData')
  ? JSON.parse(localStorage.getItem('userInfoData'))
  : null
const reactPlugin = new ReactPlugin()
const config = getConfig()

// Only initialize ApplicationInsights if not in test environment and connection string exists
const shouldInitializeAI = process.env.NODE_ENV !== 'test' && config?.APP_INSIGHTS_CONNECTION_STR

const ai = new ApplicationInsights({
  config: {
    connectionString: config?.APP_INSIGHTS_CONNECTION_STR || '',
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
})

// Only load AppInsights if it should be initialized
if (shouldInitializeAI) {
  ai.loadAppInsights()
  ai.trackPageView({
    properties: {
      user: userInfoData?.email || null
    }
  })
}

export default (Component) => withAITracking(reactPlugin, Component)
export const appInsights = ai.appInsights
export { ai, reactPlugin }
